import React, { useState } from 'react';
import styles from './index.module.scss';
import { Popover } from 'antd';
import { apiHolder as api, apis } from 'api';
import useMsgCallback from '@web-common/hooks/useMsgCallback';
import { ReactComponent as IconQuestion } from '@/images/icons/mail/question.svg';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const Header = () => {
    const [visible, setVisible] = useState(false);
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const isNotSirius = productVersionId !== 'sirius';
    useMsgCallback('writePageDataExchange', e => {
        const { eventStrData } = e;
        if (eventStrData && (eventStrData === 'writePageWindowCreated' || eventStrData === 'writeTabCreated')) {
            setVisible(false);
        }
    });
    const handleWriteBtnClick = () => {
        if (isNotSirius) {
            SiriusMessage.error({
                content: getIn18Text('QINGXIANSHENGJIDAO'),
            });
            return;
        }
        mailApi.doWriteMailToContact();
    };
    const popoverContent = (React.createElement("div", { className: styles.popContentWrap },
        React.createElement("div", { className: styles.steps },
            React.createElement("span", null, "1"),
            React.createElement("span", null, getIn18Text('JINRUYOUXIANGMO'))),
        React.createElement("div", { className: styles.steps },
            React.createElement("span", null, "2"),
            React.createElement("span", null, getIn18Text('DIANJITIANJIA\u201C'))),
        React.createElement("div", { className: styles.imgInfo }),
        React.createElement("div", { className: styles.steps },
            React.createElement("span", null, "3"),
            React.createElement("span", null, getIn18Text('BIANJIYOUJIANNEI'))),
        React.createElement("div", { className: styles.btn, onClick: handleWriteBtnClick }, getIn18Text('QUSHISHI'))));
    return (React.createElement("div", { className: styles.header },
        React.createElement("div", null, getIn18Text('XUNZHANG')),
        React.createElement("div", { className: styles.headerRight },
            getIn18Text('RUHEBANFAXUN'),
            React.createElement(Popover, { overlayClassName: "header-popover-container", content: popoverContent, placement: "bottomRight", trigger: "click", onVisibleChange: v => {
                    setVisible(v);
                    if (v) {
                        trackApi.track('pcContact_click_contactsDetailPage_medalWall_howToAwardMedals​');
                    }
                }, visible: visible, arrowPointAtCenter: true, autoAdjustOverflow: true, destroyTooltipOnHide: true },
                React.createElement(IconQuestion, null)))));
};
export default Header;
